import { countryName } from '@shared/countries';

/** Same-origin country hint; unavailable detection must never guess India or block signup. */
export async function detectSignupCountry(): Promise<string | null> {
  try {
    const response = await fetch('/api/location', {
      cache: 'no-store',
      signal: AbortSignal.timeout(2500),
    });
    if (!response.ok) return null;
    const data = (await response.json()) as { country?: unknown };
    return typeof data.country === 'string' ? countryName(data.country) : null;
  } catch {
    return null;
  }
}
